import React from 'react';
import Loadable from '@/components/common/loadable';

const Product = Loadable({
  loader: () => import('@/components/product'),
});

export default () => <Product />;
